import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class TopMenuService {
	getMenu(code: string): Observable<MenuItem[]> {
		if (code == 'top' || code == 'bottom') {
			return new Observable(observer => {
				observer.next([
					{
						name: 'Novinky',
						url: '/novinky/více'
					},
					{
						name: 'Nápověda',
						url: '/napoveda'
					}
				]);

				observer.complete();
			});
		}
		else if (code == 'backend') {
			return new Observable(observer => {
				observer.next([
					{
						name: 'Transakce',
						url: '/sm/transactions'
					},
					{
						name: 'Moje nabídky',
						url: '/sm/offers'
					},
					{
						name: 'Šablony',
						url: '/sm/templates'
					}
				]);

				observer.complete();
			});
		}

		return new Observable(o => o.complete());
	}
}

export interface MenuItem {
	name: string;
	url: string;
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/services/top-menu.service.ts